/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {AoaBoardService} from './aoa-board.service';
import {AoaBoardSubspecialtyModule} from './subspecialty/aoa-board-subspecialty.module';

@NgModule({
    imports: [AoaBoardSubspecialtyModule],
    providers: [
        AoaBoardService
    ]
})
export class AoaBoardModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/aoa/aoa-board.module.ts